import { action } from 'mobx'
import BaseStore from '@common/Table/store'
import Api from '@api/xi_feng/jiamengGoods.js'
class Store extends BaseStore {
  id

  $listApi = Api.getSuperviseList

  @action
  setStoreData = (type, value) => {
    this[type] = value
  }

  $getParams = () => {
    return {
      ...this.$params,
      property_id: this.id
    }
  }

  @action
  addSupervise = async id => {
    const { success } = await Api.addSupervise({ product_id: id })
    if (success) {
      this.$list.find(item => item.id === id).is_selected = 1
      this.tableForceUpdate()
    }
  }

  @action
  removeFranchise = async id => {
    const { success } = await Api.removeFranchise({ id })
    if (success) {
      this.$list.find(item => item.id === id).is_selected = 0
      this.tableForceUpdate()
    }
  }
}

export default Store
